export default "__VITE_ASSET__xFJsFIYL__"